export default {
      id: "youtube-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#youtube-usage",
      toString: function () {
        return this.url;
      }
    }